import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/cog.svg";
var CogOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  CogOutline_default as default
};
